import MenuItemMinimized from './MenuItemMinimized'
import falttenedMenuList from '../util/falttenedMenuList'

const menuList = falttenedMenuList()

/**
 * sample MenuItem in Minimized mode
 * <MenuItemMinimized text="Accounts" image={Accounts} linkTo={'21'} />
 * <MenuItemMinimized text="Locations" image={Locations} linkTo={'23'} />
 * It is rendered dynamically using the JSON Object
 */
const MenusMinimized = () => {
  return (
    <>
      {menuList.map((menuItem, index) => (
        <MenuItemMinimized
          key={`${menuItem.name}${index}`}
          text={menuItem.text}
          image={menuItem.image}
          linkTo={menuItem.linkTo}
        />
      ))}
    </>
  )
}

export default MenusMinimized
